<template>
    <div class="sidebar" >
        <ui-overlay-load v-if="loader.form" />

        <div class="sidebar-header">
            <div class="header">
                <div class="title"><i class="fal fa-user"></i> Selecionar Usuários</div>
                <button class="button-close" @click="hide">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </div>

        <div class="sidebar-body scroll-color" ref="scroller">
            <div class="filters">
                <div class="row mb-10" >
                    <ui-select-2 v-model="form.data.groups"
                        :data="leadUsersType"
                        :search="true"
                        :multiple="true"
                        :loading="loader.groups"
                        label="Perfil de usuário"
                        item-label="label"
                        class="mb-10"
                        align="left"
                        @input="selectUsersTypeHandle" />

                    <ui-select-2 v-model="form.data.teams"
                        :data="leadUsersTeams"
                        :disabled="layout.disableInputSelectTeams"
                        :search="true"
                        :multiple="true"
                        :loading="loader.teams"
                        label="Equipe"
                        item-label="label"
                        align="right"
                        @input="selectTeamsHandle" />
                </div>
                <div class="row mb-10">
                    <ui-select-2 v-model="form.data.supervisors"
                        :data="leadUsersSupervisors"
                        :disabled="layout.disableInputSelectSupervisors"
                        :search="true"
                        :multiple="true"
                        :label="configurations.groups.supervisor"
                        :loading="loader.supervisors"
                        item-label="label"
                        align="left"
                        @input="selectSupervisorsHandle" />

                    <ui-select-2 v-model="form.data.managers"
                        :data="leadUsersManagers"
                        :disabled="layout.disableInputSelectManagers"
                        :loading="loader.managers"
                        :search="true"
                        :multiple="true"
                        :label="configurations.groups.manager"
                        item-label="label"
                        align="right"
                        @input="selectManagersHandle" />
                </div>
                <div class="reset-filters">
                    <button class="button" type="button" @click="resetFilters" >Resetar Filtros</button>
                </div>
            </div>

            <div class="input-group-search">
                <ui-search-box v-model="form.data.search" event="marketing-queue-users-search" placeholder="Digite o nome, cpf, creci ou email do usuário" />
            </div>

            <div class="select-user">
                <div class="ui-select-user">
                    <div class="select-all" v-if="data.length > 0">
                        <button class="button" type="button" @click="selectAll">{{ btnSelectAllLabel }}</button>
                    </div>

                    <div class="items-wrapper" v-if="data.length > 0">
                        <div class="items-scroller">
                            <div class="items">
                                <div v-for="(item, id) in data"
                                    :key="`${item.id}-item-${id}`"
                                    :class="{ active: item.active }"
                                    class="item"
                                    @click="select(item)">
                                    <div class="ui-user-card">
                                        <ui-image :src="getImgCDN(item.photo)"
                                            :alt="item.first_name"
                                            class="circle"
                                            h="35"
                                            w="35" />
                                        <div>
                                            <div class="ui-user-card-title" v-if="item.first_name">{{item.first_name }}</div>
                                            <div class="ui-user-card-subtitle" v-if="item.group">{{ getFormattedGroup(item) }}</div>
                                        </div>
                                    </div>
                                    <i class="fal fa-check"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ui-no-content" v-else>
                        <div class="title">Nenhum item foi encontrado.</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="sidebar-footer">
            <ui-button design="lg block primary" @click="submit">Adicionar Usuários</ui-button>
        </div>
    </div>
</template>

<script>
    import { uiOverlayLoad, uiSearchBox, uiImage } from '@/components/ui'
    import { uiSelect2 } from '@/components/ui/form'
    import { uiButton } from '@/components/ui/buttons'

    import { user, team } from '@/services/axios'
    import { storage } from '@/services/storage'

    import helpers from '@/mixins/helpers'

    import { mapGetters, mapActions } from 'vuex'

    const defaultLayout = () => {
        return {
            showInputUpload: true,
            showUploadSuccess: false,
        }
    }

    const defaultLoader = () => {
        return {
            selectUser: false,
            fileUpload: false,
            form: false
        }
    }

    const perPage = 250

    export default {
        name: 'ui-select-user',

        components: {
            uiSearchBox,
            uiSelect2,
            uiButton,
            uiOverlayLoad,
            uiImage
        },

        mixins: [ helpers ],

        data() {
            return {
                queueStatusToggle: true,
                layout: {
                    showInputUpload: true,
                    showUploadSuccess: false,
                    disableInputSelectTeams: false,
                    disableInputSelectSupervisors: false,
                    disableInputSelectManagers: false,
                },
                loader: {
                    selectUser: false,
                    fileUpload: false,
                    form: false,
                    mounted: false,

                    groups: false,
                    teams: false,
                    supervisors: false,
                    managers: false
                },
                configurations: {
                    groups: {
						admin: storage.get('label_admin'),
						collaborator: storage.get('label_collaborator'),
						supervisor: storage.get('label_supervisor'),
						manager: storage.get('label_manager'),
						broker: storage.get('label_broker'),
					},
                    lastPage: 1,
                    lastSearch: '',
                    groupsPage: 1,
                },
                form: {
                    data: {
                        groups: [],
                        teams: [],
                        supervisors: [],
                        managers: [],
                        page: 1,
                        search: '',
                        users: [],
                        removed: [],
                        added: [],
                    }
                },
                data: [],
                selecteds: []
            }
        },

        beforeDestroy() {
            this.$store.dispatch('lead/clearFilterOptions')

            this.$root.$off('marketing-queue-users-search')
            this.$root.$off('sidebar-select-users-reload-data')
            this.$root.$off('sidebar-select-user-load-form')
        },

        mounted: async function () {
            this.$nextTick(() => {
                if (this.$refs.scroller) this.$refs.scroller.addEventListener('scroll', this.scrollHandler)
            })

            this.$root.$on('marketing-queue-users-search', async (param) => {
                // Valida se o valor inserido é um CPF
                await this.maskCPF(param)
                
                if (!this.form.data.search || this.configurations.last_search !== param){
                    this.configurations.last_page = param
                    this.form.data.page = 1
                }

                this.$nextTick(() => {
                    this.$set(this.loader, 'form', true)
                    this.loadUsers(false, true)
                })
            })

            this.$root.$on('sidebar-select-users-reload-data', () => {
                this.$nextTick(() => {
                    this.$set(this.form.data, 'users', Object.values(this.leadQueue.lusers).map(lead => lead.user))
                    this.loadUsers(false, true)
                })
            })

            this.$root.$on('sidebar-select-user-load-form', async () => {
                await this.loadForm()

                this.$set(this.loader, 'mounted', true)
            })  
        },

        computed: {
            ...mapGetters('lead', {
                leadQueue: 'getQueue',
                leadUsersType: 'getTypes',
                leadUsersTeams: 'getTeams',
                leadUsersSupervisors: 'getSupervisors',
                leadUsersManagers: 'getManagers',
            }),
            btnSelectAllLabel() {
                let total = this.data.length

                return this.selecteds.length < total ? 'Selecionar todos' : 'Remover todos'
            },
        },

        methods: {
            ...mapActions('lead', {
                setFilterData: 'setSelectUser'
            }),
            /**
             * Executa o médoto de esconder o sidebar
             * O método vem do template
             */
            hide() {
                this.$root.$emit('close-sidebar-select-user')
            },
            /**
             * Carrega os dados necessários para montar o formulário
             */
            loadForm: async function () {
                this.$set(this.loader, 'form', true)

                try {
                    /** Busca os grupos/perfis de usuários cadastrados no sistema */
                    this.$set(this.loader, 'groups', true)
                    let response = await user.getAll('groups', {})
                    /** Gera as opções dos grupos/perfis de usuários */
                    this.setFilterData({
                        name: 'type',
                        data: Object.values(response.data)
                                .filter(group => group.name !== 'system')
                                .map(group => {
                                    let label = ''
                                    let systemDefault = true

                                    switch (group.name) {
                                        case 'admin':
                                        case 'supervisor':
                                        case 'collaborator':
                                        case 'manager':
                                        case 'broker':
                                            label = this.configurations.groups[group.name]
                                            break

                                        default:
                                            label = group.name
                                            systemDefault = false
                                            break
                                    }

                                    return { id: group.id, value: group.name, label, default: systemDefault }
                                })
                    })
                    this.$set(this.loader, 'groups', false)

                    await this.getTeams()
                    await this.getSupervisors(null)
                    await this.getManagers(null)

                    this.$set(this.form.data, 'users', Object.values(this.leadQueue.lusers).map(lead => lead.user))

                    this.loadUsers(false, true)
                } catch (error) {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    this.$set(this.loader, 'form', false)
                }
            },
            /**
             * Reseta o layout
             */
            resetLayout() {
                this.layout = { ...defaultLayout() }
            },

            /**
             * Reseta os loadings
             */
            resetLoader() {
                this.loader = { ...defaultLoader() }
            },
            /**
             * Busca os dados dos usuários na base de dados de acordo com os filtros
             */
            getUsers() {
                let params = null

                let groups = this.form.data.groups.map(e => {
                    return e.value
                })

                let teams = this.form.data.teams.map(e => {
                    return e.value
                })

                let supervisors = this.form.data.supervisors.map(e => {
                    return e.value
                })

                let managers = this.form.data.managers.map(e => {
                    return e.value
                })

                params = {
                    groups: groups.length ? groups.join(',') : null,
                    teams: teams.length ? teams.join(',') : null,
                    supervisors: supervisors.length ? supervisors.join(',') : null,
                    managers: managers.length ? managers.join(',') : null,
                    per_page: 50,
                    page: this.form.data.page
                }

                if (this.form.data.search) {
                    params = {
                        q: null 
                    }

                    params['q'] = this.form.data.search
                }

                return user.getAll('filter', params)
            },
            /**
             * Carrega os dados dos usuários disponíveis para seleção
             */
            loadUsers(add = false, search = false, scroll = false) {
                    if ((this.configurations.lastPage > this.form.data.page) || search) {
                        
                        if (scroll) this.$set(this.form.data, 'page', this.form.data.page += 1)

                        this.getUsers()
                            .then(response => {
                                    let data = response.data.data
                                    this.configurations.lastPage = response.data.last_page
                                    const fdata = add && !search ? [...this.data, ...data] : [...data]

                                    const fdata2 = fdata.filter(e => {
                                        if (!this.form.data.users.some( el => el.id === e.id )) {
                                            return {...e, active: false}
                                        }
                                    })
                                    this.data = [...fdata2]
                            })
                            .catch(error => {
                                if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                            })
                            .finally(() => {
                                this.$set(this.loader, 'selectUser', false)
                                this.$set(this.loader, 'form', false)
                            })
                    }else{
                        this.$set(this.loader, 'form', false)
                    }  
            },
            /**
             * Evento de selecao do tipo de usuario
             * Caso a selecao seja apenas adm, colaborador ou dinâmico desabilita os
             * outros filtros
             */
            selectUsersTypeHandle(e){
                if (this.loader.mounted) {
                    if (this.configurations.lastPage === this.form.data.page) this.$set(this.form.data, 'page', 1)
                    this.$set(this.loader, 'form', true)
                    this.loadUsers(false, true)
                    if (e.length == 1 && ['admin', 'colaborator'].includes(e[0].value)) {
                        this.$set(this.layout, 'disableInputSelectTeams', true)
                        this.$set(this.layout, 'disableInputSelectSupervisors', true)
                        this.$set(this.layout, 'disableInputSelectManagers', true)
                    }else{
                        this.$set(this.layout, 'disableInputSelectTeams', false)
                        this.$set(this.layout, 'disableInputSelectSupervisors', false)
                        this.$set(this.layout, 'disableInputSelectManagers', false)
                    }

                }
            },
            /**
             * Evento de selecao da equipe.
             * Ao selecionar equipes os filtros de supervisor e gerentes devem ser
             * alterados apenas para aqueles que fazem partes das equipes selecionadas.
             */
            selectTeamsHandle: async function(e){
                if (this.loader.mounted) {
                    this.$set(this.loader, 'form', true)

                    if (this.configurations.lastPage === this.form.data.page) this.$set(this.form.data, 'page', 1)

                    let teams = e.map(e => {
                        return e.value
                    })

                    await this.getSupervisors({ teams: teams.join(',') })
                    await this.getManagers({ teams: teams.join(',') })

                    this.loadUsers(false, true)
                }
            },
            /**
             * Evento de selecao dos supervisores.
             * Ao selecionar supervisores o filtro de gerente deve ser alterado apenas para os gerentes
             * que fazem parte das equipes dos supervisores selecionados.
             */
            selectSupervisorsHandle: async function(e){
                if (this.loader.mounted) {
                    this.$set(this.loader, 'form', true)

                    if (this.configurations.lastPage === this.form.data.page) this.$set(this.form.data, 'page', 1)

                    let teams = this.form.data.teams.map(e => {
                        return e.value
                    })

                    let supervisors = e.map(e => {
                        return e.value
                    })

                    await this.getManagers({ 
                        teams: teams.join(','),
                        supervisors: supervisors.join(',')
                    })

                    this.loadUsers(false, true)
                }
            },
            /**
             * Evento de selecao dos gerentes
             * Apenas altera o valor final dos filtros.
             */
            selectManagersHandle: async function(){
                if (this.loader.mounted) {
                    this.$set(this.loader, 'form', true)

                    if (this.configurations.lastPage === this.form.data.page) this.$set(this.form.data, 'page', 1)

                    this.loadUsers(false, true)
                }
            },
            /**
             * Busca as equipes
            */
            async getTeams() {
                this.$set(this.loader, 'teams', true)
                /** Carrega as opções de equipes cadastradas */
                const response = await team.getAll('', {per_page: perPage})
                if (response.data && response.data.total) {
                    let data = Object.values(response.data.data).map(team => {
                        return { id: team.id, value: team.id, label: team.name }
                    })

                    this.setFilterData({
                        name: 'teams',
                        data: data
                    })
                }
                this.$set(this.loader, 'teams', false)
            },

            /**
             * Busca os supervisores
             */
            getSupervisors: async function(value) {
                this.$set(this.loader, 'supervisors', true)
                let response = null
                let params = {
                    groups: 'supervisor',
                    per_page: perPage,
                }
                if (value) {
                    params = Object.assign(params, value)
                }

                // Busca os supervisores que fazem parte das equipes
                response = await user.getAll('filter', params)

                    let data = Object.values(response.data.data).map(e => {
                        return { id: e.id, value: e.supervisor_id, label: e.first_name, team: e.manager_team_name }
                    })

                    this.setFilterData({
                        name: 'supervisors',
                        data: data
                    })

                this.$set(this.loader, 'supervisors', false)
            },
            /**
             * Busca os gerentes
             */
            getManagers: async function(value) {
                this.$set(this.loader, 'managers', true)
                let response = null
                let params = {
                    groups: 'manager',
                    per_page: perPage,
                }
                if (value) {
                    params = Object.assign(params, value)
                }

                // Busca os gerentes que fazem parte das equipes
                response = await user.getAll('filter', params)

                if (response.data.data && response.data.data.length) {
                    let data = []
                    Object.values(response.data.data).forEach(e => {
                        if (e.group === 'manager') data.push({ id: e.id, value: e.manager_id, label: e.first_name, team: e.manager_team_name })
                    })

                    this.setFilterData({
                        name: 'managers',
                        data: data
                    })
                }

                this.$set(this.loader, 'managers', false)
            },
            /**
             * Trata o evento de quando um usuário é selecionado
             */
            userSelectHandler(value) {
                const selecteds = Object.values(value).map(user => user.id)
                let current = []
                if (this.leadQueue && this.leadQueue.lusers) current = Object.values(this.leadQueue.lusers).map(lead => lead.user_id)
                const removed = Object.values(current).filter(id => !selecteds.includes(id))
                const added = Object.values(value).filter(user => !current.includes(user.id)).map(user => user.id)
                
                this.$set(this.form.data, 'removed', removed)
                this.$set(this.form.data, 'added', added)
                this.$set(this.form.data, 'users', value)
            },
            /**
             * Evento disparado ao clicar no botão de submit
             * Emit um evento 'selected'
             */
            submit() {
                /** Verifica se usuários foram adicionados na fila de leads */
                
                if (this.form.data.added.length) {
                    this.$gtm.trackEvent({
                        event: "fac_button_click",
                        category: 'vuejs-origens',
                        action: "click",
                        label: 'Adicionar Usuários',
                    })
                    this.$root.$emit('select-user-input', this.form.data.added)

                    this.$set(this.form.data, 'added', [])
                    this.selecteds = []
                    this.resetFilters()
                }
            },

            /**
             * Ouve o evento de scroll e emit um evento 'load-more' assim que 
             * chega ao final da tela. Apenas do sidebar da direita.
             * Usado para fazer scroll infinito.
             */
            scrollHandler(event) {
                const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight
                if (bottom) {
                    this.$set(this.loader, 'form', true)
                    this.$nextTick(() => {
                        this.loadUsers(true, false, true)
                    })
                }
            },

            /**
             * Reseta os filtros de usuários.
             */
            resetFilters(){
                this.$set(this.loader, 'mounted', false)
                
                this.$set(this.form.data, 'groups', [])
                this.$set(this.form.data, 'teams', [])
                this.$set(this.form.data, 'supervisors', [])
                this.$set(this.form.data, 'managers', [])
                
                this.$set(this.loader, 'mounted', true)
            },

            /**
             * Aplica a mascara de de CPF
             * Só aplica para strings de 11 caracteres e CPF válidos
             * Usado para enviar o CPF da pesquisa já formatado. (A API espera o valor formatado)
             */
            async maskCPF(value) {
                return new Promise((resolve) => {
                    value = typeof value != 'string' ? value.toString() : value

                    // Tirar formatação
                    value = value.trim().replace(/[^\d]+/g, '')

                    // Verifica se é um CPF válido
                    if (value.length == 11) {
                        value = value.padStart(11, '0')
                        value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
                        
                        this.$nextTick(() => {
                            this.$set(this.form.data, 'search', value)

                            resolve()
                        })
                    }else{
                        resolve()
                    }
                })
            },

            /**
             * Seleciona todos os usuários que ainda não foram selecionados
             */
            selectAll() {
                let total = this.data.length

                if (this.selecteds.length < total) {
                    this.selecteds = []
                    this.data.map((e) => {
                        this.select(e)
                    })
                } else {
                    this.selecteds = []
                }
            },

            select(item) {
               let index = this.selecteds.findIndex((x) => x.id == item.id)
               let itemId = this.data.findIndex((x) => x.id == item.id)

                if (index < 0) {
                    this.$set(this.selecteds, this.selecteds.length, item)
                    this.$set(this.form.data.users, this.form.data.users.length, item)
                    this.$set(this.form.data.added, this.form.data.added.length, item.id)
                    this.data[itemId].active = true
                } else {
                    let removeItemIndex = 0
                    removeItemIndex = this.form.data.users.findIndex((x) => x.id == item.id)
                    this.form.data.users.splice(removeItemIndex, 1)

                    removeItemIndex = this.form.data.added.findIndex((x) => x == item.id)
                    this.form.data.added.splice(removeItemIndex, 1)

                    this.selecteds.splice(index, 1)
                    this.data[itemId].active = false
                }
            },

            randomID(id) {
                return id + Math.random().toString(16).slice(2)
            },
            getFormattedGroup(user) {
                let groupLabel = ''
                let teamLabel = ''
                switch (user.group) {
                    case 'admin':
                    case 'supervisor':
                    case 'collaborator':
                    case 'manager':
                    case 'broker':
                        groupLabel = this.configurations.groups[user.group]
                        break

                    default:
                        groupLabel = user.group
                        break
                }

                if (!['admin', 'collaborator'].includes(user.group)) {
                    teamLabel = 'Equipe: '
                    teamLabel += (user.team_name || user[`${user.group}_team_name`]) || ' - '
                }

                return `${groupLabel} ${teamLabel}`
            },
        },

    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
